module.exports = __webpack_public_path__ + "static/left-chevron-a4dfc0d40602adbfdad993a39979975f.png";